module.exports = __webpack_public_path__ + "static/media/foto.aa9f56a0.jpg";